var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_625_6801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7 8.58172 10.5817 5 15 5H25C29.4183 5 33 8.58172 33 13V23C33 27.4183 29.4183 31 25 31H15C10.5817 31 7 27.4183 7 23V13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5C10.3056 4.5 6.5 8.30558 6.5 13V23C6.5 27.6944 10.3056 31.5 15 31.5H25C29.6944 31.5 33.5 27.6944 33.5 23V13C33.5 8.30558 29.6944 4.5 25 4.5H15Z",
    stroke: "#708099",
    strokeOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_6801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 20.73V22.25C15.4998 22.39 15.6098 22.5 15.7498 22.5H17.2698C17.3348 22.5 17.3998 22.475 17.4448 22.425L22.9048 16.97L21.0298 15.095L15.5748 20.55C15.5248 20.6 15.4998 20.66 15.4998 20.73ZM24.3548 15.52C24.5498 15.325 24.5498 15.01 24.3548 14.815L23.1848 13.645C22.9898 13.45 22.6748 13.45 22.4798 13.645L21.5648 14.56L23.4398 16.435L24.3548 15.52Z",
    fill: "#5030E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_625_6801",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_625_6801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_625_6801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_6801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(13.9998 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.09c988f5aecfbbb91c28c59a93111fe9.svg";
export { ForwardRef as ReactComponent };